import WhatWeDo from '../sections/what-we-do/WhatWeDo';
import App from '../App';

window.App = App;
window.Section = WhatWeDo;


